var View = require('views/base/view');
var ProgressService = require('services/progress-service');

var CourseModuleView = View.extend({
  template: require('./templates/course-module'),
  className: 'panel panel-default',
  listen: {
    addedToParent: 'loaded'
  },
  loaded: function(){
    //this.container = this.el;
    this.delegate('click', '.btn-progress.btn-success', function(e){
      var button = e.currentTarget;
      var mod = EF.modules.find({key: button.attributes['data-module'].value});
      var act = mod.activities.find({key: button.attributes['data-activity'].value});
      var page = act.pages.find({key: button.attributes['data-page'].value});
      page.set('completed', true);
      this.wasOpen = true;
      EF.ContentProvider.CourseModuleService.saveModuleProgress(this, page, mod);
    });
    this.delegate('click', '.btn-progress.btn-danger', function(e){
      var button = e.currentTarget;
      var mod = EF.modules.find({key: button.attributes['data-module'].value});
      var act = mod.activities.find({key: button.attributes['data-activity'].value});
      var page = act.pages.find({key: button.attributes['data-page'].value});
      mod.currentActivity = act;
      var prevPage = mod.getPreviousPageByKey(page.get('key'));
      mod.clearProgress();
      if (prevPage){
        prevPage.set('completed', true);
      }
      this.wasOpen = true;
      EF.ContentProvider.CourseModuleService.saveModuleProgress(this, page, mod);
    });
    this.delegate('click', '.progress-grant-all', function(e){
      this.wasOpen = this.$('.collapse').hasClass('in');
      var mod = EF.modules.find({key: e.currentTarget.attributes['data-module'].value});
      mod.completeAllPages();
      EF.ContentProvider.CourseModuleService.saveModule(mod);
      this.render();
    });
    this.delegate('click', '.progress-remove-all', function(e){
      this.wasOpen = this.$('.collapse').hasClass('in');
      var mod = EF.modules.find({key: e.currentTarget.attributes['data-module'].value});
      mod.clearProgress();
      mod.save();
      this.render();
    });
    //this.$('.collapse').head().collapse('show');
  },
  getTemplateData: function(){
    var data = this.model.serialize();
    if (this.wasOpen === undefined){
      this.wasOpen = !EF.module && EF.modules.indexOf(this.model) === 0;
      this.wasOpen = this.wasOpen || (EF.module && EF.module === this.model);
    }
    data.wasOpen = this.wasOpen;
    data.local = EF.options.local;
    return data;
  }
});

module.exports = CourseModuleView;